import EditIcon from '@material-ui/icons/Edit';
import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import RichTextEditor, { EditorValue } from 'react-rte';
import Button from '../../../../../../components/Button';
import Input from '../../../../../../components/Input';
import { IPage } from '../../../../../../store/pages/store';
import { RTE_TOOLBARCONFIG } from '../../Utils/RTE_TOOLBARCONFIG';

interface IProps {
  content?: string;
  id: number;
  name?: string;
  onDelete: (id: number) => Promise<any>;
  onSave: (page: Partial<IPage>) => Promise<any>;
}

export const PageContent = ({ onSave, onDelete, content, name, id }: IProps) => {
  const [text, setText] = useState<EditorValue>(
    content
      ? RichTextEditor.createValueFromString(content, 'markdown')
      : RichTextEditor.createEmptyValue()
  );
  const [title, setTitle] = useState(name || '');
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    if (id) {
      setEditMode(false);
      setText(RichTextEditor.createValueFromString(content || '', 'markdown'));
      setTitle(name || '');
    }
  }, [id]);

  const save = async () => {
    await onSave({ id, content: text.toString('markdown'), name: title });
    setEditMode(false);
  };

  const onRemove = async () => {
    return onDelete(id);
  };

  const onEdit = () => {
    setEditMode(true);
  };
  const onCancel = () => {
    setEditMode(false);
  };

  const onChange = (event: any) => {
    setTitle(event.target.value);
  };

  return (
    <div className="page-content-wrapper">
      <div className="header">
        <div className={`view-actions hideable ${editMode ? 'hidden' : ''}`}>
          <Button className="button edit-button" color="primary" onClick={onEdit}>
            <div className="icon-container">
              <EditIcon className="edit-icon" />
            </div>
            edit
          </Button>
        </div>
        <div className={`edit-actions hideable ${editMode ? '' : 'hidden'}`}>
          <Button className="button page-content-delete" color="primary" onClick={onRemove}>
            delete
          </Button>
          <Button className="button page-content-cancel" color="primary" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            className="button page-content-save"
            color="primary"
            variant="contained"
            onClick={save}
            disabled={title === ''}
          >
            Save
          </Button>
        </div>
      </div>
      <div className="page-editor">
        <div className={`view-mode hideable ${editMode ? 'hidden' : ''}`}>
          <div className="tag">Page Name</div>
          <div className="value">{name}</div>
          <div className="tag">Page Content</div>
          <div className="content-space">
            <ReactMarkdown source={content} className="markdown" />
          </div>
        </div>
        <div className={`edit-mode hideable ${editMode ? '' : 'hidden'}`}>
          <Input
            type="text"
            placeholder="Page Name"
            label="Page Name"
            id="page-name"
            value={title}
            onChange={onChange}
          />
          <RichTextEditor
            className="rte-editor"
            value={text}
            onChange={setText}
            toolbarConfig={RTE_TOOLBARCONFIG}
          />
        </div>
      </div>
    </div>
  );
};
